import { StateNameEnum } from '@base/store/state-name.enum';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './reducer';

const state_selector = createFeatureSelector<fromReducer.State>(StateNameEnum.core_ui);
export const loadingData = createSelector(state_selector, (state: fromReducer.State) => state.loadingData);
